import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, TemplateRef, ViewChild} from "@angular/core";
import {AbstractListView} from "../../../core/visbos-core/ui/components/abstract-list-view";
import {FormBuilder} from "@angular/forms";
import {DatatableComponent} from "../../../core/visbos-core/ui/components/datatable/datatable.component";
import {ProcurementService} from "../../services/procurement-service/procurement.service";
import {SessionActions} from "../../../shared/actions/session.actions";
import {MessageType} from "../../../shared/redux-store/session/session.types";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";

@Component({
  selector: 'vb-shopping-cart-items-table',
  templateUrl: './shopping-cart-items-table.component.html',
  styleUrls: ['./shopping-cart-items-table.component.css']
})
export class ShoppingCartItemsTableComponent extends AbstractListView implements OnInit, AfterViewInit {

  @ViewChild('stockDetails')
  articleDetailsTmpl: TemplateRef<any>;

  @ViewChild('editAmountTmpl')
  editAmountTmpl: TemplateRef<any>;

  @ViewChild('stockCartItemsTable')
  table: DatatableComponent;

  editable: { [cuid: string]: boolean };

  messages = {
    emptyMessage: 'Keine Artikel im Warenkorb vorhanden',
    totalMessage: 'Artikel im Warenkorb insgesamt'
  };

  private _shoppingCartItems: any[] = [];

  get shoppingCartItems(): any[] {
    return this._shoppingCartItems;
  }

  @Input()
  set shoppingCartItems(value: any[]) {
    this._shoppingCartItems = value;
    this.rows = value;
  }

  constructor(private fb: FormBuilder, private procurementService: ProcurementService,
              sessionActions: SessionActions, cd: ChangeDetectorRef) {

    super(sessionActions, cd);

  }

  ngOnInit() {

    this.searchTerm = this.fb.control(null);

    this.dataSubscriptions.push(
      this.searchTerm.valueChanges.pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe((term: any) => this.filterItems(term))
    );

    this.columns = [
      {prop: 'article_number', name: 'Art.-Nr.', minWidth: 100, maxWidth: 150, flexGrow: 2},
      {prop: 'article_label', name: 'Bezeichner', minWidth: 250, flexGrow: 3},
      {prop: 'amount', name: 'Anzahl', cellTemplate: this.editAmountTmpl, minWidth: 60, maxWidth: 100, flexGrow: 1},
      {prop: 'packing_unit', name: 'Einheit', minWidth: 100, maxWidth: 150, flexGrow: 2},
      {
        prop: 'price',
        name: 'Einzelpreis',
        cellTemplate: this.table.formatCurrencyTmpl,
        minWidth: 60,
        maxWidth: 100,
        flexGrow: 1
      },
      {
        prop: 'total_price',
        name: 'Gesamtpreis',
        cellTemplate: this.table.formatCurrencyTmpl,
        minWidth: 60,
        maxWidth: 100,
        flexGrow: 1
      },
      /*
       {name: 'Bestände in Lagern', cellTemplate: this.stocksCell},*/
    ];

  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.cd.detectChanges();

    // Hack for ordering
    let col = this.table.table._columns[0];
    this.table.table.onColumnResize({column: col, newValue: 50});

    this.cd.detectChanges();
  }

  filterItems(searchTerm) {
    if (!searchTerm || searchTerm == "") {
      this.rows = this.shoppingCartItems;
    } else {
      if (this.shoppingCartItems) {
        this.rows = this.shoppingCartItems.filter((si: any) => this.findStringInTable(si, this.columns, searchTerm));
      }
    }
  }

  onCellUpdate(row, res, index) {
    this.procurementService.updateShoppingCartItem(row.cuid, res, false).toPromise()
      .then(res => {

      })
      .catch(err => {
        this.sessionActions.pushMessage("Es ist ein Fehler beim Ändern des Warenkorbs aufgetreten!", MessageType.ERROR, "Warenkorb", true);
      });
  }

  onItemRemove(item) {
    this.procurementService.removeShoppingCartItem(item.cuid).toPromise()
      .then(res => {
        console.info("Gelöscht");
      })
      .catch(err => {
        console.error("Fehler beim Löschen");
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/procurement/shopping-cart-items-table/shopping-cart-items-table.component.ts